// The boot stream's planted defects, switched on from the spike's one faults switch (`?faults=recast-hang,boot-throw`;
// specs add them through `RPG_FAULTS`), because they must be set before the page boots. Each one lives beside what it
// breaks; this file only reads the switch:
//   recast-hang      @rpg/nav NAV_FAULTS.initNeverResolves: Recast's init never resolves (the boot spec must fail)
//   boot-throw       the spike's world step throws (the fail screen must show)
//   timer-progress   @rpg/boot screen faults.timerProgress: the bar creeps on a timer (the progress check must fail)
//   no-fail-screen   @rpg/boot screen faults.noFailScreen: failures are swallowed (the fail-screen check must fail)
// They join the spike's `__rpg.faults()` record as a read-only group: they act at boot, so switching one later throws.
import type { FaultGroup } from "../faults";

/** The boot defects' names. */
export const BOOT_FAULT_NAMES = ["recast-hang", "boot-throw", "timer-progress", "no-fail-screen"] as const;
export type BootFault = (typeof BOOT_FAULT_NAMES)[number];

/** The boot faults the page's `?faults=` switch turns on (other modules' names are theirs to read). */
export function bootFaults(search: string = location.search): Set<BootFault> {
  const v = new URLSearchParams(search).get("faults");
  return new Set((v ?? "").split(",").filter((n): n is BootFault => (BOOT_FAULT_NAMES as readonly string[]).includes(n)));
}

/** The boot faults as a group of the joined record: readable; a change after boot throws (it can't take effect). */
export function bootFaultGroup(on: ReadonlySet<BootFault>): FaultGroup {
  return {
    names: BOOT_FAULT_NAMES,
    get: (n) => on.has(n as BootFault),
    set: (n, value) => {
      if (value !== on.has(n as BootFault)) throw new Error(`fault "${n}" acts at boot: switch it with ?faults=${n} instead`);
    },
  };
}
